import React, {useState, useEffect} from 'react';

import './styles.scss';
import {connect} from 'react-redux';
import {addToWizard, setWizard} from '../../../store/actions';
import {compose} from 'redux';
import {Column, Row} from '../../../components/layout';
import Header2 from '../../../components/headers/header2';
import {strings, functionalitiesAliasMap} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import Stepper from '../../../components/stepper';
import {Link} from 'react-router-dom';
import {useHistory} from 'react-router';
import {Icons} from '../../../util/icons';
import Icon from '../../../components/icon';
import {uriMemberData, uriGetTitular} from '../../../api/endpoints';
import {get} from '../../../api/api';
import NewInvoiceValidation from './steps/invoice-validation/NewInvoiceValidation';
import NewReimbursementData from './steps/reimbursement-data/NewReimbursementData';
import NewPatientValidation from './steps/new-patient-validation';
export interface ReimbursementRequestPageProps {
  wizard: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  labels: typeof strings.pt.createRefund;
  labelsIban: typeof strings.pt.ibanRefunds;
  buStyles: any;
  busFuncMap: any;
  titular: any;
}

const ReimbursementRequest: React.FC<ReimbursementRequestPageProps> = ({
  wizard,
  setWizard,
  addToWizard,
  labels,
  labelsIban,
  buStyles,
  busFuncMap,
  titular,
}) => {
  const history = useHistory();
  const [currentStepValid, setCurrentStepValid] = useState(false);
  const [step2Files, setStep2Files] = useState<any[]>([]);
  const [currentTitular, setCurrentTitular] = useState(titular);
  const [specificErrorMessage, setSpecificErrorMessage] = useState<any>();

  const featureName = 'ReimbursementHistory-Request';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const setFiles = (files: any[]) => {
    setStep2Files(files);
  };

  const getTitular = async (selectedMember: any) => {
    try {
      let titular: any = await get(
        uriGetTitular(selectedMember.buId, selectedMember.famId),
        false,
        0,
        featureName,
      );
      if (titular?.data) {
        return titular?.data;
      }
      return {iban: {}};
    } catch {}
  };

  // IBAN INTERNACIONAL
  const validateIban = async (patientSelected: any) => {
    var canProceed = true;
    const createRefundActive = busFuncMap[patientSelected.buId]?.find(
      (func: any) =>
        func?.featureTemplateAlias === functionalitiesAliasMap.createRefund &&
        func?.isVisible,
    );

    const ibanFunc = busFuncMap[patientSelected.buId]?.find(
      (func: any) => func.featureTemplateAlias === functionalitiesAliasMap.iban,
    );

    const ibanFuncActive = ibanFunc?.isVisible;

    const ibanIsEnabledStr = ibanFunc?.labels?.find(
      (str: any) => str.labelTemplateAlias === 'ibanRefunds_ibanIsEnabled',
    ) || {text: labelsIban?.ibanRefunds_ibanIsEnabled};
    const bankAccountDataHolder = ibanFunc?.labels?.find(
      (str: any) =>
        str.labelTemplateAlias === 'ibanRefunds_bankAccountDataHolder',
    ) || {text: labelsIban?.ibanRefunds_bankAccountDataHolder};
    const bankAccountDataRequired = ibanFunc?.labels?.find(
      (str: any) =>
        str.labelTemplateAlias ===
        'ibanRefunds_bankAccountDataRequiredForRefunds',
    ) || {text: labelsIban?.ibanRefunds_bankAccountDataRequiredForRefunds};

    if (!createRefundActive) {
      canProceed = false;
    } else {
      if (!ibanFuncActive) {
        if (titular?.iban) {
          canProceed = true;
          return canProceed;
        }
        // else {
        //   canProceed = bankAccountDataRequired?.text == '0';
        // }
      } else {
        switch (bankAccountDataHolder?.text) {
          case 'SUBSCRIBER': {
            // lógica titular
            switch (bankAccountDataRequired?.text) {
              case '1': {
                const titularPatientSelected =
                  await getTitular(patientSelected);
                setCurrentTitular(
                  titularPatientSelected
                    ? titularPatientSelected
                    : currentTitular,
                );
                canProceed = titularPatientSelected?.iban;
                if (!canProceed) {
                  // se for titular e puder alterar iban
                  if (
                    titularPatientSelected?.memId === patientSelected?.memId &&
                    titularPatientSelected?.buId === patientSelected?.buId
                  ) {
                    if (ibanIsEnabledStr.text === '1') {
                      setSpecificErrorMessage(
                        <p>
                          {labelsIban?.ibanRefunds_fillIbanMyData}{' '}
                          <a
                            onClick={() =>
                              history.push({
                                pathname: '/perfil',
                                state: {patientSelected: patientSelected},
                              })
                            }
                            style={{
                              color: buStyles?.primaryColor || colors.blue,
                            }}>
                            {labelsIban.ibanRefunds_fillIbanMyDataLink}
                          </a>
                        </p>,
                      );
                    } else {
                      // se for titular e não puder alterar iban
                      // setSpecificErrorMessage(
                      //   <p>
                      //     {
                      //       labelsIban?.ibanRefunds_fillIbanAskInsuranceCompany
                      //     }{' '}
                      //   </p>
                      // );

                      canProceed = true;
                    }
                  } else {
                    // se não for titular
                    // setSpecificErrorMessage(
                    //   <p className="semibold">
                    //     {labelsIban?.ibanRefunds_fillIbanAskTitular}
                    //   </p>
                    // );

                    canProceed = true;
                  }
                }
                break;
              }
              case '0': {
                canProceed = true;
                break;
              }
            }

            break;
          }
          case 'INDIVIDUAL': {
            switch (bankAccountDataRequired?.text) {
              case '1': {
                // obter iban do paciente selecionado
                const memberData: any = await get(
                  uriMemberData(
                    patientSelected?.buId,
                    patientSelected?.memId,
                    patientSelected?.famId,
                  ),
                  false,
                  0,
                  featureName,
                );

                canProceed = !!memberData?.data?.iban;
                if (!canProceed) {
                  setSpecificErrorMessage(
                    <p>
                      {labelsIban?.ibanRefunds_fillIbanMyData}{' '}
                      <a
                        onClick={() =>
                          history.push({
                            pathname: '/perfil',
                            state: {patientSelected: memberData.data},
                          })
                        }
                        style={{
                          color: buStyles?.primaryColor || colors.blue,
                        }}>
                        {labelsIban.ibanRefunds_fillIbanMyDataLink}
                      </a>
                    </p>,
                  );
                }
                break;
              }
              case '0': {
                canProceed = true;
                break;
              }
            }
            break;
          }
        }
      }
    }
    return canProceed;
  };

  const renderStepperFeatureEnabled = () => {
    return [
      {
        index: 0,
        label: labels?.createRefund_patient,
        component: (onSubmit: any, nextStepHandler: any) => {
          return (
            <NewPatientValidation
              onSubmit={onSubmit}
              nextStep={nextStepHandler}
              hideExit={true}
              validationMethod={(patientSelected: any) =>
                validateIban(patientSelected)
              }
              functionalityAtiva={functionalitiesAliasMap.createRefund}
              currentTitular={currentTitular}
              specificErrorMessage={specificErrorMessage}
            />
          );
        },
        onSubmit: (values: any) =>
          addToWizard({insuranceValidation: {...values}}),
      },
      {
        index: 1,
        label: labels?.createRefund_invoice,
        component: (onSubmit: any, nextStepHandler: any) => (
          <NewInvoiceValidation
            onSubmit={onSubmit}
            nextStep={nextStepHandler}
            setValid={(valid: any) => {
              if (valid !== currentStepValid) setCurrentStepValid(valid);
            }}
            valid={currentStepValid}
            titleOfButton={labels?.createRefund_confirmSend}
            showPopup={false}
            nextStepFlag={false}
            setOldFiles={(files: any[]) => setFiles(files)}
          />
        ),
        onSubmit: async (values: any) => {
          addToWizard({dataValidation: {...values}});
        },
      },
      {
        index: 2,
        label: labels?.createRefund_data,
        component: (onSubmit: any, nextStepHandler: any) => (
          <NewReimbursementData
            onSubmit={onSubmit}
            nextStep={nextStepHandler}
            setValid={(valid: any) => {
              if (valid !== currentStepValid) setCurrentStepValid(valid);
            }}
            valid={currentStepValid}
            oldFiles={step2Files}
            setOldFiles={(files: any[]) => setFiles(files)}
          />
        ),
        onSubmit: async (values: any, {validateForm}: any) => {
          const errors = await validateForm(values);
          if (Object.keys(errors).length > 0) {
            return;
          }
          addToWizard({ActivateAccount: {...values}});
        },
      },
    ];
  };

  return (
    <>
      <Column className="reimbursement-main-column">
        <Column>
          <Column className="reimbursement-title-container">
            <Row className="reimbursement-header-row">
              <Header2
                className="reimbursement-header"
                style={{
                  ...fonts.XL,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {labels?.createRefund_refundRequest}
              </Header2>
            </Row>
            <Row className="reimbursement-subtitle-row">
              <p style={{...fonts.M, color: colors.black}}>
                {labels?.createRefund_hoursToPayment}
              </p>
            </Row>
          </Column>

          <Stepper
            className="reimbursement-stepper"
            step={wizard.step}
            currentStepValid={currentStepValid}
            steps={renderStepperFeatureEnabled() as any}
          />

          <Link
            onClick={async () => {
              setWizard({});
            }}
            to="/historico-reembolsos"
            className="reimbursement-header-content-exit-label"
            style={{
              ...fonts.SM,
              ...fonts.SemiBold,
              color: buStyles?.primaryColor || colors.blue,
            }}>
            {labels?.createRefund_leaveRequest}
            <Icon
              className="reimbursement-header-content-close-icon svg-close-button inline-svg-close-button"
              name={Icons.CLOSE}
              width={'12'}
              height={'12'}
              changeViewbox={true}
              strokeWidth={'0.5'}
            />
          </Link>
        </Column>
      </Column>
    </>
  );
};

const mapStateToProps = ({
  wizard,
  strings,
  globalStyles,
  busFuncMap,
  titular,
}: any) => ({
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  buStyles: globalStyles.value,
  busFuncMap: busFuncMap.value,
  labelsIban: strings.value.pt.ibanRefunds,
  titular: titular.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReimbursementRequest),
);
